import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Reveal";

export default function Faq({ faqs }) {
  return (
    <section id="faq" className="bg-[#F2EFE9] py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5 lg:px-8">
        <SectionHead
          index="06"
          label="FAQ"
          title="Questions, answered straight."
          description="Everything retailers and enterprises ask us before they switch."
          testId="faq-head"
        />
        <Reveal>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {(faqs || []).map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="rounded-xl border border-[#E2DDD5] bg-white px-6 shadow-sm transition-colors duration-300 data-[state=open]:border-[#0E8A8A]/40"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-left font-syne text-base font-semibold text-[#0F1B2B] hover:no-underline sm:text-lg">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-[#5A6578] sm:text-base">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
